export default "__VITE_ASSET__BUYV8QIP__"